import type { ComponentProps } from 'react'
import { Route, Switch } from 'react-router-dom'
import { useLocaleStrippedLocation } from './useLocaleStrippedLocation'
import { useCorporateEventsTransformedLocation } from 'corporateEvents/hooks/useCorporateEventsTransformedLocation'

/**
 * Matches existing `/:regionCode/...` routes when an optional locale segment is
 * present after the region, e.g. `/au/de-DE/shop` matches `/au/shop`.
 *
 * TODO: this also means descendants currently see the stripped pathname from
 * `useLocation()`. For example, a filter interaction that rebuilds the URL with
 * `replaceWithRegion(location.pathname, nextSearch)` can navigate from
 * `/au/de-DE/shop` to `/au/shop?...`, dropping the locale segment. This is
 * acceptable while only accepts/logs the locale and does not use it as the
 * display language, but needs fix before we use locale in URL to dictate language
 */
export default function LocaleAwareSwitch(props: ComponentProps<typeof Switch>) {
  const localeStrippedLocation = useLocaleStrippedLocation()
  const matchLocation = useCorporateEventsTransformedLocation(localeStrippedLocation)
  return (
    <Route location={matchLocation}>
      <Switch {...props} location={matchLocation} />
    </Route>
  )
}
